// Global imports
import { Accordion, ContentEditor, Heading } from '~/components'

// Types
import type { PortableTextBlock } from '@portabletext/react'

interface FaqListItem {
  question?: string
  answer?: PortableTextBlock[]
}

interface BlockFaqListProps {
  title?: string
  items?: FaqListItem[]
  footerContent?: PortableTextBlock[]
}

// Main export
export default function BlockFaqList({
  title,
  items,
  footerContent,
}: BlockFaqListProps) {
  // A question with no wording has nothing to show, so it is left out. The
  // FAQPage JSON-LD for these questions is built by the route
  const faqs = items?.filter(e => e.question) ?? []

  if (!faqs.length) return null

  return (
    <div className="container">
      {title && (
        <Heading
          className="mb-10 text-center"
          tag="h2"
          size="h5"
        >
          {title}
        </Heading>
      )}
      <div className="mx-auto max-w-[54.5rem]">
        <Accordion>
          {faqs.map((e, i) => (
            <Accordion.Section
              key={i}
              title={e.question ?? ''}
              className="mb-4"
            >
              {e.answer && <ContentEditor content={e.answer} />}
            </Accordion.Section>
          ))}
        </Accordion>
        {footerContent && (
          <div className="mt-6 text-center [&_p]:mb-0">
            <ContentEditor content={footerContent} />
          </div>
        )}
      </div>
    </div>
  )
}
